import React from 'react';
import Layout from '../components/layout';
import { graphql, Link } from 'gatsby';

export default ({ data }) => {
  const rawPhrases = data.allMarkdownRemark.edges.flatMap(({ node }) => {
    if (node.frontmatter.phrases == null) return [];

    return node.frontmatter.phrases.map(phrase => ({
      slug: node.fields.slug,
      phrase,
    }));
  });

  const shuffledRawPhrases = shuffle(rawPhrases);
  const numPhrases = Math.min(getNumPhrasesFromWindowSize(), shuffledRawPhrases.length);

  const phrases = shuffledRawPhrases.slice(0, numPhrases);
  const xys = getXYs(numPhrases);

  return (
    <Layout>
      <div style={{height: '100%', width: '100%'}}>
        <svg xmlns="http://www.w3.org/2000/svg" height={'100%'} width={'100%'}>
          {
            phrases.map((phrase, i) => {
              const xy = xys[i];
              const style = getRandomStyle()
              return (
                <Link to={`/works${phrase.slug}`} key={phrase.phrase}>
                  <text x={`${xy[0]}%`} y={`${xy[1]}%`} style={style}>{phrase.phrase}</text>
                </Link>
              )
            })
          }
        </svg>
      </div>
    </Layout>
  );
};

export const query = graphql`
  query {
    allMarkdownRemark {
      edges {
        node {
          id
          frontmatter {
            phrases
          }
          fields {
            slug
          }
        }
      }
    }
  }
`

const getXYs = (num) => {
  let xys = [];
  for (let i = 0; i < num; i++) {
    let xy;
    for (let j = 0; j < 10; j++) {
      xy = getXY(isMobile());
      if (!doesCollide(xy, xys)) {
        break;
      }
    }
    xys.push(xy);
  }
  return xys;
}

const doesCollide = (xy, existingXYs) => {
  for (let existingXY of existingXYs) {
    const xDiff = Math.abs(xy[0] - existingXY[0]);
    const yDiff = Math.abs(xy[1] - existingXY[1]);
    if (yDiff < 2 && xDiff < 25) return true;
    if (yDiff < 5 && xDiff < 15) return true;
  }
  return false;
}

const getXY = (isMobile) => {
  const rawX = getRandomFloat(-1, 1);
  const maxAbsRawY = Math.sqrt(1 - rawX * rawX);
  const rawY = getRandomFloat(-maxAbsRawY, maxAbsRawY);

  const x = isMobile ? 10 + 15 * rawX : 35 + 35 * rawX;
  const y = 45 + 40 * rawY

  return [x, y];
}

const getRandomStyle = () => {
  const [stroke, fill] = getRandomStrokes();
  let fontSize;
  if (isMobile()) {
    fontSize = fill === 'white' ? getRandomFloat(20, 30) : getRandomFloat(14, 20);
  } else {
    fontSize = fill === 'white' ? getRandomFloat(26, 44) : getRandomFloat(14, 26);
  }

  return {
    fontFamily: 'serif',
    fontSize: fontSize,
    stroke: stroke,
    fill: fill,
  }
}

const getRandomStrokes = () => {
  if (Math.random() < 0.15) {
    return ['black', 'white']
  }

  const v = Math.floor(getRandomFloat(2, 8));
  const colorCode = `#${v}${v}${v}`;
  return [colorCode, colorCode];
}

const getNumPhrasesFromWindowSize = () => {
  const isClient = typeof window === 'object';
  if (!isClient) {
    return 15;
  }
  if (isMobile()) {
    return 10;
  }

  const area = window.innerWidth * window.innerHeight;
  return Math.floor(area / 60000);
}

const shuffle = (arr) => {
  for(let i = arr.length - 1; i > 0; i--){
    const r = Math.floor(Math.random() * (i + 1));
    const tmp = arr[i];
    arr[i] = arr[r];
    arr[r] = tmp;
  }
  return arr
}

const getRandomFloat = (min, max) => {
  return min + Math.random() * (max - min);
}

const isMobile = () => {
  const isClient = typeof window === 'object';
  if (!isClient) {
    return false;
  }
  return window.innerWidth < 600;
}

